import { filter, isEmpty, path } from 'ramda'
import { useChangeFilterValue, useFilter } from '@btime/react-contexts'
import React from 'react'

import { SmallText, Text } from '../../../components/presentation/Text'
import { getSelectedPlaceLevelsValues } from './_helpers/selectedPlaceLevels'
import CheckboxesFilterSideModal from '../../../components/filter/CheckboxesFilterSideModal'
import CheckboxesList from '../../../components/form/CheckboxesList'
import PlaceLevelsLoader, { usePlaceLevels } from '../_load/PlaceLevelsLoader'
import SelectAllPlaceLevelsLink from '../../placeLevels/SelectAllPlaceLevelsLink'

const renderOptions = (options, values, setValue) => {
  return (
    <CheckboxesList
      cleanLabel
      renderLabel={item => (
        <>
          <Text>{item.label}</Text>
          <SmallText size="xsmall">{path(['origin', 'resume'], item)}</SmallText>
        </>
      )}
      value={values}
      onChange={setValue}
      options={options || []}
    />
  )
}

const LevelValuesFilterSideModal = ({ field, label, type, levelId, parentId, parentIds, onClose, ...props }) => {
  const filter = useFilter()
  const value = filter[field] || []
  const handleChange = useChangeFilterValue()
  const filterParams = {
    types: type,
    levelIds: levelId
    // parentIds: parentId || (!isEmpty(parentIds) ? parentIds : undefined)
  }

  return (
    <CheckboxesFilterSideModal
      label={label || 'Level'}
      value={value}
      renderValue={values => getSelectedPlaceLevelsValues(values, type, levelId)}
      dataHook={usePlaceLevels}
      Loader={PlaceLevelsLoader}
      loaderProps={filterParams}
      useSearch
      renderOptions={renderOptions}
      renderHeaderRightContent={params => <SelectAllPlaceLevelsLink filter={filterParams} {...params} />}
      onClose={v => {
        handleChange(field, v)
        onClose()
      }}
      {...props}
    />
  )
}

export default LevelValuesFilterSideModal
